import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=f6af52a8&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"
import style0 from "./Step1.vue?vue&type=style&index=0&id=f6af52a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af52a8",
  null
  
)

export default component.exports